import Cookie from 'common/services/util/-RFC.Cookie';

const _directiveDependencies = [];
const _controllerDependencies = ['$timeout', '$location', '$window', '$scope', '$rootScope'];

class CookiePolicyController {

    constructor($timeout, $location, $window, $scope, $rootScope) {

        this.$timeout = $timeout;
        this.$window = $window;
        this.isNotificationVisible = false;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.cookiePolicyUrl =
            CWCONFIG.partnerConfig.translationsLinks.generalPrivacy.replace('{language}', CWCONFIG.language);

        this.$scope.webSite = CWCONFIG.partnerConfig.translationsLinks.webSite;
        this.$scope.brandName = CWCONFIG.partnerConfig.name;

        const hasCookiePolicy = Cookie.get(CWCONFIG.cookie.cookiePolicy);
        const isRestricted = $location.path().indexOf('not-allowed') > -1;

        if (!hasCookiePolicy && !isRestricted) {

            this.showNotification();

        }

    }

    closeNotification() {

        this.isNotificationVisible = false;

        Cookie.set(CWCONFIG.cookie.cookiePolicy, true, {
            path: '/',
            domain: CWCONFIG.cookie.domain,
            expires: 9999,
        });

        this.$rootScope.cookieBannerHeight = { 'padding-bottom': '11px' };
        this.$rootScope.cmaDisclaimerHeight = { 'padding-bottom': '0' };

    }

    showNotification() {

        this.$timeout(() => {

            this.isNotificationVisible = true;

            angular.element('#policyUrl a').on('click', () => {

                window.open(this.cookiePolicyUrl, ' _blank');

            });

        }, 500);

    }

}


class CookiePolicyDirective {

    constructor() {

        this.template = require('./cookie-policy.html');
        this.restrict = 'E';
        this.replace = true;

        _controllerDependencies.push(($timeout, $location, $window, $scope, $rootScope) =>
            new CookiePolicyController($timeout, $location, $window, $scope, $rootScope));
        this.controller = _controllerDependencies;
        this.controllerAs = 'cookiePolicyCtrl';

    }

}

_directiveDependencies.push(() => new CookiePolicyDirective());

angular.module('directives')
    .directive('cookiePolicy', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/cookie-policy/cookie-policy.js